import React from 'react';
import { Card, CardContent } from '../ui/Card';
import { ActivityIcon, AlertCircleIcon, CheckCircle2Icon, AlertTriangleIcon } from 'lucide-react';
import { DashboardStats } from '../../types';
interface SummaryCardsProps {
  stats: DashboardStats;
}
export function SummaryCards({
  stats
}: SummaryCardsProps) {
  const cards = [{
    title: 'Total de Logs',
    value: stats.total.toLocaleString(),
    icon: ActivityIcon,
    color: 'text-blue-500',
    bgColor: 'bg-blue-500/10',
    subtitle: 'Todas las entradas'
  }, {
    title: 'Éxito (SC-2xx)',
    value: stats.success.toLocaleString(),
    icon: CheckCircle2Icon,
    color: 'text-green-500',
    bgColor: 'bg-green-500/10',
    subtitle: stats.total > 0 ? `${Math.round(stats.success / stats.total * 100)}% del total` : '0%'
  }, {
    title: 'Error (SC-5xx)',
    value: stats.failed.toLocaleString(),
    icon: AlertCircleIcon,
    color: 'text-red-500',
    bgColor: 'bg-red-500/10',
    subtitle: stats.total > 0 ? `${Math.round(stats.failed / stats.total * 100)}% del total` : '0%'
  }, {
    title: 'Advertencia (SC-4xx)',
    value: stats.pending.toLocaleString(),
    icon: AlertTriangleIcon,
    color: 'text-yellow-500',
    bgColor: 'bg-yellow-500/10',
    subtitle: stats.total > 0 ? `${Math.round(stats.pending / stats.total * 100)}% del total` : '0%'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-106">
      {cards.map((card, i) => {
      const Icon = card.icon;
      return <Card key={i} className="border-gray-200 bg-white shadow-sm hover:shadow-md transition-all" data-id="element-107">
            <CardContent className="px-6 py-5" data-id="element-108">
              <div className="flex items-center justify-between" data-id="element-109">
                <div className="flex-1" data-id="element-110">
                  <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide" data-id="element-111">
                    {card.title}
                  </p>
                  <h3 className="text-3xl font-bold tracking-tight text-foreground mt-2" data-id="element-112">
                    {card.value}
                  </h3>
                </div>
                <div className={`p-3 rounded-xl ${card.bgColor}`} data-id="element-113">
                  <Icon className={`w-5 h-5 ${card.color}`} data-id="element-114" />
                </div>
              </div>
              <div className="mt-3 flex items-center text-xs" data-id="element-115">
                <span className="text-muted-foreground" data-id="element-116">{card.subtitle}</span>
              </div>
            </CardContent>
          </Card>;
    })}
    </div>;
}